// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Dancing+Script&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --glow-color-pitch: #4eff00;
}

.bgpadd{
    background:rgb(0, 0, 0);
    /* overflow-x: hidden; */
}

.cardtop{
      position: relative;}
.caro{
    position: absolute;
    background: linear-gradient(90deg,rgba(0, 0, 255), red);
    color: white;
    border: 1px blue solid;
    border-radius: 3px;
    top:80%;
    transform: translateY(-20%);
}
.cardtop{width:100%;height:230px}
.headfooterpad{background: rgba(0, 0, 0, 0.671);}
.paddfooter{margin-top:360px;margin-bottom:-100px;}

.pitch_alley_title{
  text-align: center;
}


.pitch_alley_blink_span{
font-size: 2rem;
}
.pitch_alley_blink{
  color: var(--glow-color-pitch);
  box-shadow: inset 0px 0px 0.5em 0px var(--glow-color-pitch),
      0px 0px 0.5em 0px var(--glow-color-pitch);

}
.pitch_alley_blink:hover{
  /* color: rgb(255, 117, 140) !important; */
  color: #4eff00;
}
.pitch_alley_blink::before{
background: none !important;
}
.pitch_alley_blink::after{
  background: none !important;
}
@media screen and (max-width:400px){
  .pitch_alley_blink_span{
 
    font-size: 1.5rem;
    }
}

@media screen and (max-width:769px) {
    .cardtop{height:300px;}
    .paddfooter{margin-top: 450px;}
}
@media screen and (max-width:600px) {
    .cardtop{height:250px;}
    .paddfooter{margin-top: 400px;}
}
.EbookMeta_Studios{width: 78%; height: 250px;}
@media screen and (min-width:768px) and (max-width:991px) {
    .EbookMeta_Studios{width: 90%; height: 230px;}
}
.EbookMeta_Studios{transition-duration:  1s;}
.EbookMeta_Studios:hover{scale: 1.1;}
@media screen and (max-width:767px) {
    .EbookStudio{display: flex; justify-content: center; }
    .EbookStudioText{text-align: center;}
}
@media screen and (max-width:577px) {
   .btnClass{margin-top: 10px;}
}

@media screen and (max-width:1200px) {
  .LandingBox{height: 550px;}
}

@media screen and (max-width:768px) {
    .LandingBox{height: 650px;}
 }
 /* @media screen and (max-width:518px) {
    .LandingBox{height: 700px;}
 } */
 @media screen and (max-width: 538px) {
  .LandingBox{height: 750px;}
}
@media screen and (max-width: 490px) {
  .LandingBox{height: 800px;}
}
 @media screen and (max-width:443px) {
    .LandingBox{height: 850px;}
 }
 @media screen and (max-width:420px) {
  .LandingBox{height: 900px;}
}
 @media screen and (max-width:380px) {
    .LandingBox{height: 1000px;} 
 }
 @media screen and (max-width:355px) {
  .LandingBox{height: 1100px;} 
}
@media screen and (max-width:317px) {
  .LandingBox{height: 1200px;} 
}
@media screen and (max-width:306px) {
  .LandingBox{height: 1300px;} 
}

 @media screen and (max-width:295px) {
    .LandingBox{height: 1400px;} 
 }


 @media screen and (max-width:768px) {
  .cardIMG{height: 205px;} 
}
 

.LandingBox{
   border: 2px solid transparent;
   border-image: linear-gradient(0deg,rgb(136, 0, 255),white,red);
   border-image-slice: 1;
   box-shadow: 2px 2px 20px rgb(136, 0, 255), 2px 2px 20px red;
   min-height: 480px;
}

.cardtop{background: #181823;}


.imga img {
    width: 100%; height: 210px;
  }
  .img1{z-index: 1;}
  .img2{position: relative; left: 160px;top: -100px;}
  
  @media screen and (max-width:724px) {
    .imga .img1{z-index: 1;}
    .imga{position:relative; margin-bottom: 130px; margin-top: 80px;}
    .img2{position: absolute;top: -100px;left: 2px;}
    .img3{position: absolute; margin-top: 50px; margin-left: 170px;}
    .img1{margin-left: 2px;margin-top: 25px;}
}


  .imga{position: relative;}
  .img3{position: absolute; top: 108px; left: -170px;}

  .img3:hover{
    scale: 1.2;
    transition-duration: 1s;
    z-index: 1;
  }
  .img1:hover{
    scale: 1.2;
    transition-duration: 1s;
    z-index: 1;
  }
  .img2:hover{
    scale: 1.2;
    transition-duration: 1s;
    z-index: 1;
  }
  
/* Bulb video */
.blub_vdo{
  width: 600px;
}

/* .pitchAlley_bgVdeo{
  width: 300px;
  height: 350px;
}

@media only screen and (max-width: 400px) {
  .pitchAlley_bgVdeo{
    width: 100px;
    height: 150px;
  }
} */

@media only screen and (max-width: 600px) {
  .blub_vdo{
    width: 300px;
  }
}

@media screen and (max-width:281px) {
  .size{font-size: 23px;}
}


.marquee {
  width: 100%;
  white-space: nowrap;
  /* overflow: hidden; */
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
  display: inline-block;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100% );
  }
}



.creatVist {
  --border-radius: 15px;
  --border-width: 4px;
  appearance: none;
  position: relative;
  padding: .5em 1em;
  border: 0;
  background-color:black;
  /* font-family: "Roboto", Arial, "Segoe UI", sans-serif; */
  font-size: 18px;
  /* font-weight: 500; */
  /* font-family: 'Happy Monkey', cursive; */
  font-weight:bold;
  color: #fff;
  z-index: 2;
 }
 
 .creatVist::after {
  --m-i: linear-gradient(#000, #000);
  --m-o: content-box, padding-box;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: var(--border-width);
  border-radius: var(--border-radius);
  background-image: conic-gradient(
     #488cfb,
     #29dbbc,
     #ddf505,
     #ff9f0e,
     #e440bb,
     #655adc,
     #488cfb
   );
  mask-image: var(--m-i), var(--m-i);
  mask-origin: var(--m-o);
  -webkit-mask-clip: var(--m-o);
  mask-composite: exclude;
  -webkit-mask-composite: destination-out;
  filter: hue-rotate(0);
  animation: rotate-hue linear 500ms infinite;
  animation-play-state: paused;
 }
 
 .creatVist:hover::after {
  animation-play-state: running;
 }
 
 @keyframes rotate-hue {
  to {
   filter: hue-rotate(1turn);
  }
 }
 
 .creatVist,
 .creatVist::after {
  box-sizing: border-box;
 }
 
 .creatVist:active {
  --border-width: 5px;
 }

 /* typing animation start */
@keyframes handwriting {
  from { width: 0; }
  to { width: 33% }
}

#handwriting {
  overflow: hidden;
  white-space: nowrap;
  font-size: 5rem;
  font-variation-settings: 'curs' 1;
  animation: handwriting 4s steps(40, end) infinite, blink-caret 0.5s infinite alternate;
}
#handwriting span{
  font-family: 'Cedarville Cursive', cursive !important;
  font-family: 'Dancing Script', cursive !important;

}

@keyframes blink-caret {
  to { border-color: transparent; }
}
/* typing animation end */











`, "",{"version":3,"sources":["webpack://./src/Padd.css"],"names":[],"mappings":"AACA;EACE,2BAA2B;AAC7B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;MACM,kBAAkB,CAAC;AACzB;IACI,kBAAkB;IAClB,uDAAuD;IACvD,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,OAAO;IACP,2BAA2B;AAC/B;AACA,SAAS,UAAU,CAAC,YAAY;AAChC,eAAe,gCAAgC,CAAC;AAChD,YAAY,gBAAgB,CAAC,oBAAoB,CAAC;;AAElD;EACE,kBAAkB;AACpB;;;AAGA;AACA,eAAe;AACf;AACA;EACE,8BAA8B;EAM5B;+CAC2C;;AAE/C;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;AACA,2BAA2B;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;;IAEE,iBAAiB;IACjB;AACJ;;AAEA;IACI,SAAS,YAAY,CAAC;IACtB,YAAY,iBAAiB,CAAC;AAClC;AACA;IACI,SAAS,YAAY,CAAC;IACtB,YAAY,iBAAiB,CAAC;AAClC;AACA,mBAAmB,UAAU,EAAE,aAAa,CAAC;AAC7C;IACI,mBAAmB,UAAU,EAAE,aAAa,CAAC;AACjD;AACA,mBAAmB,wBAAwB,CAAC;AAC5C,yBAAyB,UAAU,CAAC;AACpC;IACI,aAAa,aAAa,EAAE,uBAAuB,EAAE;IACrD,iBAAiB,kBAAkB,CAAC;AACxC;AACA;GACG,UAAU,gBAAgB,CAAC;AAC9B;;AAEA;EACE,YAAY,aAAa,CAAC;AAC5B;;AAEA;IACI,YAAY,aAAa,CAAC;CAC7B;CACA;;IAEG;CACH;EACC,YAAY,aAAa,CAAC;AAC5B;AACA;EACE,YAAY,aAAa,CAAC;AAC5B;CACC;IACG,YAAY,aAAa,CAAC;CAC7B;CACA;EACC,YAAY,aAAa,CAAC;AAC5B;CACC;IACG,YAAY,cAAc,CAAC;CAC9B;CACA;EACC,YAAY,cAAc,CAAC;AAC7B;AACA;EACE,YAAY,cAAc,CAAC;AAC7B;AACA;EACE,YAAY,cAAc,CAAC;AAC7B;;CAEC;IACG,YAAY,cAAc,CAAC;CAC9B;;;CAGA;EACC,SAAS,aAAa,CAAC;AACzB;;;AAGA;GACG,6BAA6B;GAC7B,8DAA8D;GAC9D,qBAAqB;GACrB,2DAA2D;GAC3D,iBAAiB;AACpB;;AAEA,SAAS,mBAAmB,CAAC;;;AAG7B;IACI,WAAW,EAAE,aAAa;EAC5B;EACA,MAAM,UAAU,CAAC;EACjB,MAAM,kBAAkB,EAAE,WAAW,CAAC,WAAW,CAAC;;EAElD;IACE,YAAY,UAAU,CAAC;IACvB,MAAM,iBAAiB,EAAE,oBAAoB,EAAE,gBAAgB,CAAC;IAChE,MAAM,kBAAkB,CAAC,WAAW,CAAC,SAAS,CAAC;IAC/C,MAAM,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,CAAC;IAC/D,MAAM,gBAAgB,CAAC,gBAAgB,CAAC;AAC5C;;;EAGE,MAAM,kBAAkB,CAAC;EACzB,MAAM,kBAAkB,EAAE,UAAU,EAAE,YAAY,CAAC;;EAEnD;IACE,UAAU;IACV,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,UAAU;IACV,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,UAAU;IACV,uBAAuB;IACvB,UAAU;EACZ;;AAEF,eAAe;AACf;EACE,YAAY;AACd;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,MAAM,eAAe,CAAC;AACxB;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;;;AAIA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,0DAA0D;EAC1D,eAAe;EACf,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,UAAU;CACX;;CAEA;EACC,kCAAkC;EAClC,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mCAAmC;EACnC;;;;;;;;IAQE;EAEF,kCAAkC;EAElC,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,uCAAuC;EACvC,qBAAqB;EACrB,2CAA2C;EAC3C,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC;GACC,yBAAyB;EAC1B;CACD;;CAEA;;EAEC,sBAAsB;CACvB;;CAEA;EACC,mBAAmB;CACpB;;CAEA,2BAA2B;AAC5B;EACE,OAAO,QAAQ,EAAE;EACjB,KAAK,WAAW;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,sFAAsF;AACxF;AACA;EACE,qDAAqD;EACrD,iDAAiD;;AAEnD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA,yBAAyB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Dancing+Script&display=swap');\r\n:root {\r\n  --glow-color-pitch: #4eff00;\r\n}\r\n\r\n.bgpadd{\r\n    background:rgb(0, 0, 0);\r\n    /* overflow-x: hidden; */\r\n}\r\n\r\n.cardtop{\r\n      position: relative;}\r\n.caro{\r\n    position: absolute;\r\n    background: linear-gradient(90deg,rgba(0, 0, 255), red);\r\n    color: white;\r\n    border: 1px blue solid;\r\n    border-radius: 3px;\r\n    top:80%;\r\n    transform: translateY(-20%);\r\n}\r\n.cardtop{width:100%;height:230px}\r\n.headfooterpad{background: rgba(0, 0, 0, 0.671);}\r\n.paddfooter{margin-top:360px;margin-bottom:-100px;}\r\n\r\n.pitch_alley_title{\r\n  text-align: center;\r\n}\r\n\r\n\r\n.pitch_alley_blink_span{\r\nfont-size: 2rem;\r\n}\r\n.pitch_alley_blink{\r\n  color: var(--glow-color-pitch);\r\n\r\n  -webkit-box-shadow: inset 0px 0px 0.5em 0px var(--glow-color-pitch),\r\n      0px 0px 0.5em 0px var(--glow-color-pitch);\r\n    -moz-box-shadow: inset 0px 0px 0.5em 0px var(--glow-color-pitch),\r\n      0px 0px 0.5em 0px var(--glow-color-pitch);\r\n    box-shadow: inset 0px 0px 0.5em 0px var(--glow-color-pitch),\r\n      0px 0px 0.5em 0px var(--glow-color-pitch);\r\n\r\n}\r\n.pitch_alley_blink:hover{\r\n  /* color: rgb(255, 117, 140) !important; */\r\n  color: #4eff00;\r\n}\r\n.pitch_alley_blink::before{\r\nbackground: none !important;\r\n}\r\n.pitch_alley_blink::after{\r\n  background: none !important;\r\n}\r\n@media screen and (max-width:400px){\r\n  .pitch_alley_blink_span{\r\n \r\n    font-size: 1.5rem;\r\n    }\r\n}\r\n\r\n@media screen and (max-width:769px) {\r\n    .cardtop{height:300px;}\r\n    .paddfooter{margin-top: 450px;}\r\n}\r\n@media screen and (max-width:600px) {\r\n    .cardtop{height:250px;}\r\n    .paddfooter{margin-top: 400px;}\r\n}\r\n.EbookMeta_Studios{width: 78%; height: 250px;}\r\n@media screen and (min-width:768px) and (max-width:991px) {\r\n    .EbookMeta_Studios{width: 90%; height: 230px;}\r\n}\r\n.EbookMeta_Studios{transition-duration:  1s;}\r\n.EbookMeta_Studios:hover{scale: 1.1;}\r\n@media screen and (max-width:767px) {\r\n    .EbookStudio{display: flex; justify-content: center; }\r\n    .EbookStudioText{text-align: center;}\r\n}\r\n@media screen and (max-width:577px) {\r\n   .btnClass{margin-top: 10px;}\r\n}\r\n\r\n@media screen and (max-width:1200px) {\r\n  .LandingBox{height: 550px;}\r\n}\r\n\r\n@media screen and (max-width:768px) {\r\n    .LandingBox{height: 650px;}\r\n }\r\n /* @media screen and (max-width:518px) {\r\n    .LandingBox{height: 700px;}\r\n } */\r\n @media screen and (max-width: 538px) {\r\n  .LandingBox{height: 750px;}\r\n}\r\n@media screen and (max-width: 490px) {\r\n  .LandingBox{height: 800px;}\r\n}\r\n @media screen and (max-width:443px) {\r\n    .LandingBox{height: 850px;}\r\n }\r\n @media screen and (max-width:420px) {\r\n  .LandingBox{height: 900px;}\r\n}\r\n @media screen and (max-width:380px) {\r\n    .LandingBox{height: 1000px;} \r\n }\r\n @media screen and (max-width:355px) {\r\n  .LandingBox{height: 1100px;} \r\n}\r\n@media screen and (max-width:317px) {\r\n  .LandingBox{height: 1200px;} \r\n}\r\n@media screen and (max-width:306px) {\r\n  .LandingBox{height: 1300px;} \r\n}\r\n\r\n @media screen and (max-width:295px) {\r\n    .LandingBox{height: 1400px;} \r\n }\r\n\r\n\r\n @media screen and (max-width:768px) {\r\n  .cardIMG{height: 205px;} \r\n}\r\n \r\n\r\n.LandingBox{\r\n   border: 2px solid transparent;\r\n   border-image: linear-gradient(0deg,rgb(136, 0, 255),white,red);\r\n   border-image-slice: 1;\r\n   box-shadow: 2px 2px 20px rgb(136, 0, 255), 2px 2px 20px red;\r\n   min-height: 480px;\r\n}\r\n\r\n.cardtop{background: #181823;}\r\n\r\n\r\n.imga img {\r\n    width: 100%; height: 210px;\r\n  }\r\n  .img1{z-index: 1;}\r\n  .img2{position: relative; left: 160px;top: -100px;}\r\n  \r\n  @media screen and (max-width:724px) {\r\n    .imga .img1{z-index: 1;}\r\n    .imga{position:relative; margin-bottom: 130px; margin-top: 80px;}\r\n    .img2{position: absolute;top: -100px;left: 2px;}\r\n    .img3{position: absolute; margin-top: 50px; margin-left: 170px;}\r\n    .img1{margin-left: 2px;margin-top: 25px;}\r\n}\r\n\r\n\r\n  .imga{position: relative;}\r\n  .img3{position: absolute; top: 108px; left: -170px;}\r\n\r\n  .img3:hover{\r\n    scale: 1.2;\r\n    transition-duration: 1s;\r\n    z-index: 1;\r\n  }\r\n  .img1:hover{\r\n    scale: 1.2;\r\n    transition-duration: 1s;\r\n    z-index: 1;\r\n  }\r\n  .img2:hover{\r\n    scale: 1.2;\r\n    transition-duration: 1s;\r\n    z-index: 1;\r\n  }\r\n  \r\n/* Bulb video */\r\n.blub_vdo{\r\n  width: 600px;\r\n}\r\n\r\n/* .pitchAlley_bgVdeo{\r\n  width: 300px;\r\n  height: 350px;\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n  .pitchAlley_bgVdeo{\r\n    width: 100px;\r\n    height: 150px;\r\n  }\r\n} */\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .blub_vdo{\r\n    width: 300px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width:281px) {\r\n  .size{font-size: 23px;}\r\n}\r\n\r\n\r\n.marquee {\r\n  width: 100%;\r\n  white-space: nowrap;\r\n  /* overflow: hidden; */\r\n  box-sizing: border-box;\r\n  animation: marquee 15s linear infinite;\r\n  display: inline-block;\r\n}\r\n\r\n@keyframes marquee {\r\n  0% {\r\n    transform: translateX(100%);\r\n  }\r\n  100% {\r\n    transform: translateX(-100% );\r\n  }\r\n}\r\n\r\n\r\n\r\n.creatVist {\r\n  --border-radius: 15px;\r\n  --border-width: 4px;\r\n  appearance: none;\r\n  position: relative;\r\n  padding: .5em 1em;\r\n  border: 0;\r\n  background-color:black;\r\n  /* font-family: \"Roboto\", Arial, \"Segoe UI\", sans-serif; */\r\n  font-size: 18px;\r\n  /* font-weight: 500; */\r\n  /* font-family: 'Happy Monkey', cursive; */\r\n  font-weight:bold;\r\n  color: #fff;\r\n  z-index: 2;\r\n }\r\n \r\n .creatVist::after {\r\n  --m-i: linear-gradient(#000, #000);\r\n  --m-o: content-box, padding-box;\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: var(--border-width);\r\n  border-radius: var(--border-radius);\r\n  background-image: conic-gradient(\r\n     #488cfb,\r\n     #29dbbc,\r\n     #ddf505,\r\n     #ff9f0e,\r\n     #e440bb,\r\n     #655adc,\r\n     #488cfb\r\n   );\r\n  -webkit-mask-image: var(--m-i), var(--m-i);\r\n  mask-image: var(--m-i), var(--m-i);\r\n  -webkit-mask-origin: var(--m-o);\r\n  mask-origin: var(--m-o);\r\n  -webkit-mask-clip: var(--m-o);\r\n  mask-composite: exclude;\r\n  -webkit-mask-composite: destination-out;\r\n  filter: hue-rotate(0);\r\n  animation: rotate-hue linear 500ms infinite;\r\n  animation-play-state: paused;\r\n }\r\n \r\n .creatVist:hover::after {\r\n  animation-play-state: running;\r\n }\r\n \r\n @keyframes rotate-hue {\r\n  to {\r\n   filter: hue-rotate(1turn);\r\n  }\r\n }\r\n \r\n .creatVist,\r\n .creatVist::after {\r\n  box-sizing: border-box;\r\n }\r\n \r\n .creatVist:active {\r\n  --border-width: 5px;\r\n }\r\n\r\n /* typing animation start */\r\n@keyframes handwriting {\r\n  from { width: 0; }\r\n  to { width: 33% }\r\n}\r\n\r\n#handwriting {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  font-size: 5rem;\r\n  font-variation-settings: 'curs' 1;\r\n  animation: handwriting 4s steps(40, end) infinite, blink-caret 0.5s infinite alternate;\r\n}\r\n#handwriting span{\r\n  font-family: 'Cedarville Cursive', cursive !important;\r\n  font-family: 'Dancing Script', cursive !important;\r\n\r\n}\r\n\r\n@keyframes blink-caret {\r\n  to { border-color: transparent; }\r\n}\r\n/* typing animation end */\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
